<template>
  <div :class="'prescription-item' + (item.isFinished ? ' opacity-50' : '')">
    <div class="prescription-content">
      <div>
        <strong>
          {{ item.name }}
        </strong>

        {{ item.manufacturer }}
      </div>

      <div class="prescription-details">
        {{ item.quantity }} {{item.times}} р. в день;
        {{ item.duration }}
      </div>
    </div>

    <div class="prescription-dates">
      <div class="prescription-interval">{{item.interval}}</div>

      <div v-if="item.startedAt" class="prescription-start">
        прием начат {{formatDate(item.startedAt)}}
      </div>

      <div
        v-else
        @click="selectPrescription(item.id)"
        class="prescription-start-button">начать</div>
    </div>

    <div v-if="item.comment" class="prescription-comment">
      <div
        @click="showComment = !showComment"
        class="pointer">
        <i class="fas fa-caret-right"></i> Комментарий врача
      </div>

      <div
        v-if="showComment"
        class="pt-3">
        {{ item.comment }}
      </div>
    </div>
  </div>
</template>

<script>
  import formatDate from '../../utils/formatDate';
  import calculateDaysCount from '../../utils/calculateDaysCount';
  import declensionNumbers from '../../utils/declensionNumbers';
  import {MS_IN_DAY, FORMAT_NAMES} from '../../constants';

  export default {
    name: 'PrescriptionItem',

    props: ['prescription', 'selectPrescription'],

    data() {
      return {
        details: false,
        showComment: false,
      };
    },

    computed: {
      item() {
        const { id, drug, startDate, finishDate, quantity, times, startedAt, isFinished, comment } = this.prescription;

        let link = '';

        for (const stock of drug.stocks) {
          if(stock.link) {
            link = stock.link;

            break;
          }
        }

        return {
          id,
          name: `${drug.name} ${drug.measure || ''} ${drug.measureUnit || ''}`,
          manufacturer: drug.manufacturer ? drug.manufacturer.name : '',
          count: this.countPerPackage,
          packages: this.packagesCount,
          duration: this.duration,
          interval: `${this.formatDate(startDate)} - ${this.formatDate(finishDate)}`,
          quantity: `${quantity} ${this.declensionNumbers(quantity, drug.format.name)}`,
          times: times.length,
          comment,
          startedAt,
          link,
          isFinished,
        };
      },

      totalCount() {
        const {startDate, finishDate, times, quantity} = this.prescription;
        const days = calculateDaysCount(startDate, finishDate);

        return days * times.length * quantity;
      },

      countPerPackage() {
        const packages = this.prescription.drug.packages.map(item => item.count);

        packages.sort((a, b) => a - b);

        for (const pack of packages) {
          if (pack >= this.totalCount) {
            return pack;
          }
        }

        return packages[packages.length - 1];
      },

      packagesCount() {
        return Math.ceil(this.totalCount / this.countPerPackage);
      },

      duration() {
        const startDate = new Date(this.prescription.startDate);
        const finishDate = new Date(this.prescription.finishDate);
        const compareDate = new Date(finishDate.getTime() + MS_IN_DAY);

        if (startDate.getDate() === compareDate.getDate()) {
          const yearsDiff = (compareDate.getFullYear() - startDate.getFullYear());

          return compareDate.getMonth() + (yearsDiff * 12) - startDate.getMonth() + ' мес.';
        }

        const durationInMs = compareDate.getTime() - startDate.getTime();
        const durationInDays = parseInt(durationInMs / MS_IN_DAY);

        if (durationInDays % 7 === 0 && durationInDays !== 0) {
          return durationInDays / 7 + 'нед.';
        }

        return durationInDays + 'дн.';
      },
    },

    methods: {
      showDetails() {
        this.details = !this.details;
      },

      formatDate(date) {
        return formatDate(new Date(date), 'd.m.y');
      },

      declensionNumbers(count, name) {
        const formatName = FORMAT_NAMES.find(item => item[0] === name);
        const [, few, one, two] = formatName || [name, name, name, name];

        return declensionNumbers(count, few, one, two);
      },
    }
  }
</script>
<style lang="scss">
  @import "../../assets/scss/variables.scss";

  .prescription-item {
    position: relative;
    border-top: 1px solid $light-gray;
    font-size: 12px;

    &:first-of-type {
      border-top: 0;
    }

    .prescription-content {
      padding: 15px 160px 15px 15px;

      .prescription-details {
        padding: 3px 0 0;
      }
    }

    .prescription-comment {
      padding: 5px 15px 10px;
      color: $primary;
    }

    .prescription-dates {
      position: absolute;
      right: 15px;
      top: 15px;
      width: 150px;
      text-align: center;

      .prescription-start {
        padding: 3px 0 0;
        color: $primary;
      }

      .prescription-start-button {
        padding: 5px 10px;
        background: $secondary;
        color: $black;
        border-radius: 15px;
      }
    }
  }
</style>
